<template>
    <modal class="AIOrderRegModel" :isShow="isShow"  @keyup.esc="hide">
        <div class="header">AI点餐注册</div>
        <div class="modal-body">
            <div class="tr-box">
                1.商户购买AI点餐客户端数:<span class="num">{{SecretDogNum}}</span> &nbsp;&nbsp;
                已注册客户端数:<span class="num">{{RegNum}}</span>
            </div>
            <div class="tr-box">2.已注册客户端列表</div>
            <div class="content-box">
                <div class="table-box">
                    <el-table class="el-table--scrollable-y" ref="singleTableRef" :data="tablePageList"  highlight-current-row style="width: 100%;" 
                        v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}">
                        <el-table-column  label="序号" width="50">
                            <template #default="scope">
                                {{scope.$index+((pageIndex-1)*pageSize)+1}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Site_Name" label="注册设备信息" min-width="120" align="left">
                            <template #default="scope">
                                {{scope.row.Site_Name}} - [{{scope.row.Site_Serial}}]
                                <span class="red" v-if="scope.row.Site_ID==Site_ID">【本站点电脑】</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="操作" width="80">
                            <template #default="scope">
                                <div class="edit" >
                                    <i class="iconfont icon-shanchu" @click="delClick(scope.row)"></i>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="bottom-search-box">
                    <!-- <key-board-input class="search"
                        type="text" v-model="varietySelect" placeholder="按名称检索" ref="searchBox"
                        isKeyEnterClose isBlurClose
                        :keyOptions="{isKeyDownEnter:true}"
                    ></key-board-input> -->
                    <div class="flex1"></div>
                    <div class="page-box-bottom">
                        <page-turning class="last-page" :pageCount="pageCount" v-model="pageIndex" type="up"><i class=" iconfont icon-fangxiangquan-left"></i></page-turning>
                        <span class="page-number">{{pageIndex}}/{{pageCount}}页</span>
                        <page-turning class="next-page" :pageCount="pageCount" v-model="pageIndex"><i class=" iconfont icon-fangxiangquan-right"></i></page-turning>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">返回</button>
            <button class="btn selected" v-if="!isRegister" @click="AISendDishRegister()">AI点餐注册</button>
        </div>
    </modal>
</template>
<script>
import { config} from '/src/common'
export default {
    name:"AIOrderRegModel",
    emits:["close"],
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
    },
    data(){
        return {
            pageSize:9,
            pageIndex:1,
            //机构授权可用站点数
            SecretDogNum:0,
            //已经注册使用的设备数
            RegNum:0,
            /**本站点是否注册过 */
            isRegister:false,
            tableList:[],
            varietySelect:""
        }
    },
    computed:{
        Site_ID(){
            return config.UUID;
        },
        /**分页数据 */
        tablePageList(){
            if(this.tableList && this.tableList.length>0){
                return this.tableList.slice(((this.pageIndex-1)*this.pageSize),this.pageIndex*this.pageSize);
            }
            return [];
        },
        pageCount(){
            let lenth=1;
            if(this.tableList && this.tableList.length>0){
                lenth=Math.ceil(this.tableList.length/this.pageSize)||1;
            }
            return lenth;
        }
    },
    mounted(){
        this.loadData();

    },
    methods:{
        hide(){
            this.$emit("close");
        },
        //加载数据
        loadData(){
            let userInfo = this.$auth.getUserInfo();
           
            const loading = this.$loading({
                text: "获取AI点餐功能的注册数据中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.GetAISendDishRegisteredInfo", {
                User_ID:userInfo.User_ID,
                Operator_Name:userInfo.Login_Name
            }).then((d)=>{
                console.log(d)
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.$message.error(d.ResponseHeader.ResultDesc)
                    return;
                }else{
                    this.SecretDogNum=d.ResponseBody?.SecretDogNum||0;
                    this.RegNum=d.ResponseBody?.RegNum||0;
                    let list=[];
                    this.isRegister=false;
                    (d.ResponseBody?.AllRegSites||[]).forEach(it=>{
                        if(it.Site_ID==this.Site_ID){//当前设备排第一
                            list.unshift(it);
                            this.isRegister=true;
                        }else{
                            list.push(it);
                        }
                    })
                    this.tableList=list;
                    this.pageIndex=1;
                }
            }).catch((e)=>{
                loading.close();
                this.$alert("AI点餐功能的注册信息数据加载失败"+e.message, "提示", {confirmButtonText: "确定"});
            });
        },
        /**点击注册 */
        aiOrderReg(){

        },
        /**点击删除 */
        delClick(row){
            this.$confirm('您确定删除【'+row.Site_Name+'】站点注册信息吗？', "提示", {
                confirmButtonText: "确定",
                cancelButtonText:"取消",
                callback: (name) => {
                    if(name=='confirm'){
                        this.delAISendDishRegister(row);
                    }
                },
            });
        },
        /**AI点餐设备注册信息删除 */
        delAISendDishRegister(item){
            const loading = this.$loading({
                text: "注册信息删除中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo= this.$auth.getUserInfo();
            this.$httpAES.post("Bestech.CloudPos.DeleteAISendDishRegister",{
                Reg_ID:item.Reg_ID,
                User_ID:userInfo.User_ID,
                Operator_Name:userInfo?.Login_Name,
            }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.$message.success("删除成功");
                    console.log("删除成功",d.ResponseBody);
                    if(item.Site_ID==this.Site_ID){//本设备删除
                        userInfo.Is_AIRegistered=false;
                        //关闭食方识别
                        this.$webBrowser.stopSFAi();
                    }
                    this.loadData();
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error('注册信息删除失败：'+e.message);
                console.log('注册信息删除失败：',e);
            })
        },
        /**AI点餐设备注册 */
        AISendDishRegister(){
            const loading = this.$loading({
                text: "AI点餐设备注册中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo= this.$auth.getUserInfo();
            this.$httpAES.post("Bestech.CloudPos.AISendDishRegister",{
                User_ID:userInfo.User_ID,
                Operator_Name:userInfo?.Login_Name,
            }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.$message.success("注册成功");
                    console.log("注册成功",d.ResponseBody)
                    userInfo.Is_AIRegistered=true;
                    this.openAI();
                    this.loadData();
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error('AI点餐设备注册失败：'+e.message);
                console.log('AI点餐设备注册失败：',e);
            })
        },
        openAI(){
            //开启食方ai识别
            this.$webBrowser.openSFAi().then(d=>{
                if(d && (d.status==0 || d.state==0)){
                    console.log("开启AI识别");
                }else{
                    this.$alert("启用AI点餐功能了,检测到AI设备未启动请先检查配置!","提示");
                }
            })
        }
    }
}
</script>
<style lang="scss">
@import './AIOrderRegModel.scss'
</style>